<template>
    <div class="system-config-container">
        <!-- 主内容区域 -->
        <div class="main-content">
            <!-- 顶部按钮组 -->
            <div class="button-group">
                <button v-for="button in mainButtons" :key="button.id" class="main-button"
                    :class="{ active: activeMainButton === button.id }" @click="handleMainButtonClick(button.id)">
                    {{ button.label }}
                </button>
            </div>

            <!-- 内容区域 -->
            <div class="content-area">
                <!-- 网站配置 -->
                <WebsiteConfig v-if="activeMainButton === 'website'" />

                <!-- 成本配置 -->
                <CostConfig v-else-if="activeMainButton === 'cost'" />

                <!-- 消费明细 -->
                <ConsumptionList v-else-if="activeMainButton === 'consumption'" />
            </div>
        </div>
    </div>
</template>

<script>
import WebsiteConfig from './SystemConfig/WebsiteConfig.vue'
import CostConfig from './SystemConfig/CostConfig.vue'
import ConsumptionList from './SystemConfig/ConsumptionList.vue'

export default {
    name: 'SystemConfig',
    components: {
        WebsiteConfig,
        CostConfig,
        ConsumptionList
    },
    data() {
        return {
            activeMainButton: 'website',
            mainButtons: [
                { id: 'website', label: '网站配置' },
                { id: 'cost', label: '成本配置' },
                { id: 'consumption', label: '消费明细' }
            ]
        }
    },
    methods: {
        handleMainButtonClick(buttonId) {
            this.activeMainButton = buttonId
        }
    }
}
</script>

<style scoped lang="scss">
.system-config-container {
    min-height: calc(100vh - 160px);
    background: transparent;
}

.main-content {
    background: hsla(0, 0%, 100%, .1);
    border-radius: 16px;
    padding: 24px;
    backdrop-filter: blur(10px);
}

.button-group {
    display: flex;
    gap: 16px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.main-button {
    padding: 12px 24px;
    background: hsla(0, 0%, 100%, .1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: #e0e6ff;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: #ff7048;
        border-color: #ff7048;
        transform: translateY(-2px);
    }

    &.active {
        background: #ff7048;
        border-color: #ff7048;
    }
}

.content-area {
    min-height: 400px;
}

@media (max-width: 768px) {
    .system-config-container {
        padding: 16px;
    }

    .button-group {
        gap: 12px;

        .main-button {
            padding: 10px 20px;
            font-size: 13px;
        }
    }
}
</style>